import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { newsData } from "../../data/news-data";
import NavItem from "../../components/NavItem";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";

const NewsPage = () => {
  const { newsId } = useParams();
  const navigate = useNavigate();
  const newsItem = newsData.find((item) => String(item.id) === newsId);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!newsItem) {
    return (
      <div className="container mx-auto py-10 px-4">News item not found.</div>
    );
  }

  const heroSrc = newsItem.image800 || newsItem.image400 || newsItem.image;
  const heroSrcSet = [
    newsItem.image400 && `${newsItem.image400} 400w`,
    newsItem.image800 && `${newsItem.image800} 800w`,
  ]
    .filter(Boolean)
    .join(", ");
  const heroSizes = "(min-width: 768px) 50vw, 100vw";

  return (
    <div>
      <div className="bg-sddarkgray pt-3 md:pt-0">
        <div className="md:flex max-w-6xl mx-auto">
          <div className="hidden md:w-1/2 md:flex md:justify-center md:items-center">
            <p className="text-white md:text-4xl font-bold px-5 leading-relaxed">
              {newsItem.title}
            </p>
          </div>
          <div className="md:w-1/2 md:px-4 ">
            <div className="relative w-full md:h-80 h-48 overflow-hidden rounded-none">
              <img
                src={heroSrc}
                srcSet={heroSrcSet || undefined}
                sizes={heroSrcSet ? heroSizes : undefined}
                alt={newsItem.title || ""}
                className="absolute inset-0 w-full h-full object-cover block"
                width={800}
                height={450}
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>

          <div className="visible md:hidden text-white font-bold text-xl p-3">
            <p>{newsItem.title}</p>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto my-5 px-2">
        <div className="max-w-none">
          <ReactMarkdown
            remarkPlugins={[remarkGfm, remarkBreaks]}
            components={{
              p: ({ children }) => (
                <p className="leading-relaxed text-sm md:text-base mb-4">
                  {children}
                </p>
              ),
              a: ({ href, children }) => (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  {children}
                </a>
              ),
              strong: ({ children }) => (
                <strong className="font-semibold">{children}</strong>
              ),
              em: ({ children }) => <em className="italic">{children}</em>,
              ul: ({ children }) => (
                <ul className="list-disc pl-5 space-y-1 mb-4">{children}</ul>
              ),
              ol: ({ children }) => (
                <ol className="list-decimal pl-5 space-y-1 mb-4">{children}</ol>
              ),
              li: ({ children }) => (
                <li className="leading-relaxed">{children}</li>
              ),
              h1: ({ children }) => (
                <h1 className="text-2xl font-bold mb-3">{children}</h1>
              ),
              h2: ({ children }) => (
                <h2 className="text-xl font-bold mb-3">{children}</h2>
              ),
              h3: ({ children }) => (
                <h3 className="text-lg font-semibold mb-2">{children}</h3>
              ),
              blockquote: ({ children }) => (
                <blockquote className="border-l-4 pl-3 italic opacity-90 mb-4">
                  {children}
                </blockquote>
              ),
              img: ({ src, alt }) => (
                <img
                  src={src || ""}
                  alt={alt || ""}
                  className="my-4 max-w-full h-auto block"
                  loading="lazy"
                  decoding="async"
                />
              ),
              code: ({ children }) => (
                <code className="rounded px-1 py-0.5">{children}</code>
              ),
              pre: ({ children }) => (
                <pre className="bg-sddarkgray text-white rounded p-3 overflow-x-auto mb-4">
                  {children}
                </pre>
              ),
            }}
          >
            {newsItem.maindescription}
          </ReactMarkdown>
        </div>

        {newsItem.buttonavaliability && (
          <a
            href={newsItem.buttonlink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="bg-sdbodywhite text-[#4C95E2] hover:text-blue-700 text-sm mt-4">
              <p>{newsItem.buttonName}</p>
            </div>
          </a>
        )}
      </div>
    </div>
  );
};

export default NewsPage;
